/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module special-characters/specialcharactersarrows
 */
import Plugin from '@src/plugins/ckeditor5-core/src/plugin';
/**
 * A plugin that provides special characters for the "Arrows" category.
 *
 *		ClassicEditor
 *			.create( {
 *				plugins: [ ..., SpecialCharacters, SpecialCharactersArrows ],
 *			} )
 *			.then( ... )
 *			.catch( ... );
 *
 * @extends module:core/plugin~Plugin
 */
export default class SpecialCharactersArrows extends Plugin {
    /**
	 * @inheritDoc
	 */
    init() {
        const editor = this.editor;
        const t = editor.t;
        editor.plugins.get('SpecialCharacters').addItems('Arrows', [
            {
                title: t('at'),
                character: '\u21D0'
            },
            {
                title: t('au'),
                character: '\u21D2'
            },
            {
                title: t('av'),
                character: '\u21D1'
            },
            {
                title: t('aw'),
                character: '\u21D3'
            },
            {
                title: t('ax'),
                character: '\u21E0'
            },
            {
                title: t('ay'),
                character: '\u21E2'
            },
            {
                title: t('az'),
                character: '\u21E1'
            },
            {
                title: t('ba'),
                character: '\u21E3'
            },
            {
                title: t('bb'),
                character: '\u21E4'
            },
            {
                title: t('bc'),
                character: '\u21E5'
            },
            {
                title: t('bd'),
                character: '\u2912'
            },
            {
                title: t('be'),
                character: '\u2913'
            },
            {
                title: t('bf'),
                character: '\u21A8'
            },
            {
                title: t('bg'),
                character: '\uD83D\uDD19'
            },
            {
                title: t('bh'),
                character: '\uD83D\uDD1A'
            },
            {
                title: t('bi'),
                character: '\uD83D\uDD1B'
            },
            {
                title: t('bj'),
                character: '\uD83D\uDD1C'
            },
            {
                title: t('bk'),
                character: '\uD83D\uDD1D'
            }
        ]);
    }
}